import React from 'react';
import Shortener from './components/Shortener';

function App(){
  return (
    <div className="App">
      <Shortener />
    </div>
  );
};

export default App;
